import { call, put, takeLatest } from "redux-saga/effects";
// Login Redux States
import {
  ADD_NOTIFICATION_TEMPLATE,
  GET_NOTIFICATION_TEMPLATE,
  EDIT_NOTIFICATION_TEMPLATE,
} from "./actionTypes";
import {
  addNotificationTemplate,
  editNotificationTemplate,
  getNotificationTemplate,
} from "../../http/UAM/notificationTemplate.helper";
import { allNotificationTemplate } from "./action";
import { decryptedValue } from "common/utility";

const encryptedtemplate = btoa("notification");

function* addNotificationTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(addNotificationTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* getNotificationTemplates({ payload: { data } }) {
  try {
    const responseFromAPI = yield call(getNotificationTemplate, data);
    if (responseFromAPI.code == 200) {
      const { data } = responseFromAPI;
      yield put(allNotificationTemplate({ data }));
    } else {
      yield put(allNotificationTemplate({ data: [] }));
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* editNotificationTemplates({ payload: { template, history } }) {
  try {
    const responseFromAPI = yield call(editNotificationTemplate, template);
    if (responseFromAPI.code == 201) {
      const user = decryptedValue(localStorage.getItem("user"));
      history(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
    }
  } catch (error) {
    console.error("error", error);
  }
}

function* NotificationtemplateSaga() {
  yield takeLatest(ADD_NOTIFICATION_TEMPLATE, addNotificationTemplates);
  yield takeLatest(GET_NOTIFICATION_TEMPLATE, getNotificationTemplates);
  yield takeLatest(EDIT_NOTIFICATION_TEMPLATE, editNotificationTemplates);
}

export default NotificationtemplateSaga;
